import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal as SemanticModal } from "semantic-ui-react";
import "./modal-dimmer.scss";

export const ModalDimmer = ({ className = "", ...props }) => (
  <SemanticModal.Dimmer
    {...props}
    className={clsx("ha-modal-dimmer", className)}
  />
);

ModalDimmer.propTypes = {
  className: PropTypes.string,
};
